import { c as _c } from "react/compiler-runtime";
import type { AgentRunOutput, AgentRunOutputAiDecision, AgentRunOutputWatchlistReview } from '@onefootprint/request-types/dashboard';
import GenericOutputView from './components/generic-output-view';
import WatchlistAgentExecutionSummary from './components/watchlist-execution-summary';
type AgentExecutionSummaryProps = {
  output: AgentRunOutput;
  showJsonView?: boolean;
};
const isWatchlistReview = (output: AgentRunOutput): output is AgentRunOutputWatchlistReview => 'agentKind' in output && output.agentKind === 'watchlist_review';
const isAiDecision = (output: AgentRunOutput): output is AgentRunOutputAiDecision => 'agentKind' in output && output.agentKind === 'ai_decision';
const AgentExecutionSummary = t0 => {
  const $ = _c(5);
  const {
    output,
    showJsonView: t1
  } = t0;
  const insideDrawer = t1 === undefined ? true : t1;
  if (isWatchlistReview(output)) {
    let t2;
    if ($[0] !== output) {
      t2 = <WatchlistAgentExecutionSummary output={output} />;
      $[0] = output;
      $[1] = t2;
    } else {
      t2 = $[1];
    }
    return t2;
  }
  if (isAiDecision(output)) {
    let t2;
    if ($[2] !== insideDrawer || $[3] !== output.output) {
      t2 = <GenericOutputView output={output.output} showJsonView={insideDrawer} />;
      $[2] = insideDrawer;
      $[3] = output.output;
      $[4] = t2;
    } else {
      t2 = $[4];
    }
    return t2;
  }
};
export default AgentExecutionSummary;